import { dayLabel } from "../earlyAccess";
import { RANGES, type Bucket, type RangeId } from "../growth";

const BUCKETS: { id: Bucket; label: string }[] = [
  { id: "day", label: "Day" },
  { id: "week", label: "Week" },
  { id: "month", label: "Month" },
];

/** "day", "week (from Monday)" or "month", for chart titles. */
export const perWord = (bucket: Bucket) =>
  bucket === "day" ? "day" : bucket === "week" ? "week (from Monday)" : "month";

/** A bucket's first day as an axis label: "17 Oct", or "Oct 2026" for months. */
export const bucketLabeller = (bucket: Bucket) => (start: string) =>
  bucket === "month"
    ? new Date(`${start}T00:00:00Z`).toLocaleDateString(undefined, { month: "short", year: "numeric", timeZone: "UTC" })
    : dayLabel(start);

/** The first column of a table view of buckets. */
export const bucketHeader = (bucket: Bucket) =>
  bucket === "day" ? "Day (UTC)" : `${bucket === "week" ? "Week" : "Month"} from`;

/** The analytics pages' range and bucket pickers, in one row above the charts. */
export function RangeControls({
  range,
  bucket,
  onRange,
  onBucket,
}: {
  range: RangeId;
  bucket: Bucket;
  onRange: (range: RangeId) => void;
  onBucket: (bucket: Bucket) => void;
}) {
  return (
    <div className="filters">
      <label>
        Range
        <select value={range} onChange={(event) => onRange(event.target.value as RangeId)}>
          {RANGES.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        Per
        <select value={bucket} onChange={(event) => onBucket(event.target.value as Bucket)}>
          {BUCKETS.map((option) => (
            <option key={option.id} value={option.id}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
